import styled from "styled-components";

export const PdfWrapper = styled.div`
  width: 40%;
  height: 100%;
  overflow-y: auto;
`;
